import axios from 'axios';
import { getConfigValue } from '../config/runtimeConfig';

const api = axios.create({
  baseURL: getConfigValue(
    'REACT_APP_API_BASE_URL',
    process.env.REACT_APP_API_BASE_URL,
    'http://localhost:8081'
  ),
  headers: {
    'Content-Type': 'application/json',
  },
});

export const sendContactMessage = (payload) =>
  api.post('/api/public/contact', payload);
